const getFileExtension = (fileName) => {
  return fileName.split('.').pop();
};

export default getFileExtension;
